export default (node) => {
  const ROLL_HEIGHT = 1005; // cm
  const ROLL_WIDTH = 53; // cm

  const heightInput = node.querySelector('[data-wallpaper-height]');
  const widthInput = node.querySelector('[data-wallpaper-width]');
  const calculateBtn = node.querySelector('[data-wallpaper-calculate]');
  const resultElement = node.querySelector('[data-wallpaper-result]');
  const quantityInput = document.querySelector('[data-quantity]');

  // Early return if required elements don't exist
  if (!heightInput || !widthInput || !calculateBtn || !resultElement) {
    return;
  }

  const answerFirst = node.dataset.answerFirst;
  const answerLastSingular = node.dataset.answerLastSingular;
  const answerLastPlural = node.dataset.answerLastPlural;

  const validateNumericInput = (event) => {
    const input = event.target;
    const value = input.value;
    const validValue = value.replace(/[^0-9]/g, '');

    if (validValue !== value) {
      // Restore cursor position
      const cursorPosition = input.selectionStart - 1;
      input.value = validValue;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }
  };

  const calculate = () => {
    let height = parseFloat(heightInput.value);
    let width = parseFloat(widthInput.value);

    if (!height || !width || height <= 0 || width <= 0) {
      resultElement.textContent = '';
      return;
    }

    const lanesPerRoll = Math.floor(ROLL_HEIGHT / height);
    const lanes = width / ROLL_WIDTH;
    const total = Math.ceil(lanes / lanesPerRoll);

    const answer = `${answerFirst} ${total} ${total === 1 ? answerLastSingular : answerLastPlural}`;
    resultElement.textContent = answer;

    // Update quantity selector if it exists and total is valid
    if (quantityInput && isFinite(total) && total > 0) {
      quantityInput.value = total;
    }
  };

  const init = () => {
    heightInput.addEventListener('input', validateNumericInput);
    widthInput.addEventListener('input', validateNumericInput);
    calculateBtn.addEventListener('click', calculate);
  };

  init();
};
